export default {
  showActorList: true,
  showVersionBar: true,
  reportMetric1Color: '#0C7FEA',
  reportMetric2Color: '#71CC28',
  baseURL: process.env.REACT_APP_WS_END_POINT
} as any;
